import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{ success: <CheckCircle2 className="h-4 w-4" />, error: <XCircle className="h-4 w-4" />, warning: <AlertTriangle className="h-4 w-4" />, info: <Info className="h-4 w-4" /> }}
      toastOptions={{
        style: { fontSize: "14px", padding: "14px 16px", borderRadius: "12px" },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:!border-emerald-500/50 group-[.toaster]:!bg-emerald-50 group-[.toaster]:!text-emerald-900 dark:group-[.toaster]:!bg-emerald-950 dark:group-[.toaster]:!text-emerald-100",
          error: "group-[.toaster]:!border-rose-500/50 group-[.toaster]:!bg-rose-50 group-[.toaster]:!text-rose-900 dark:group-[.toaster]:!bg-rose-950 dark:group-[.toaster]:!text-rose-100",
          info: "group-[.toaster]:!border-sky-500/50 group-[.toaster]:!bg-sky-50 group-[.toaster]:!text-sky-900 dark:group-[.toaster]:!bg-sky-950 dark:group-[.toaster]:!text-sky-100",
          warning: "group-[.toaster]:!border-amber-500/50 group-[.toaster]:!bg-amber-50 group-[.toaster]:!text-amber-900 dark:group-[.toaster]:!bg-amber-950 dark:group-[.toaster]:!text-amber-100",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
